import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/App.scss';
import Home from './pages/Home';
import ProjectDetails from './pages/ProjectDetails';
import Navbar from './components/Navbar';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { socialLinks } from './data';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main style={{ marginTop: '80px' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/project/:slug" element={<ProjectDetails />} />
          </Routes>
        </main>

        <footer className="footer">
          <div className="footer-socials">
             <a href={socialLinks.github} aria-label="GitHub Profile" target="_blank" rel="noreferrer"><FaGithub /></a>
             <a href={socialLinks.linkedin} aria-label="LinkedIn Profile" target="_blank" rel="noreferrer"><FaLinkedin /></a>
          </div>
          <p className="footer-text">Designed & Built by Petar Gjuzelov</p>
          <p className="footer-sub">2026 &copy; Full-Stack Developer</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;